import { type AxiosRequestConfig } from "axios";

import { $streemApiV1 } from "shared/boot/api";
import { type StreamRequestFilters } from "shared/helpers/StreamFilters";
import { type MentionType } from "shared/types/mentions";

interface MatchingSyndicationsResponse {
  syndications_matching_stream: {
    [id: number]: boolean;
  };
}

// eslint-disable-next-line import/prefer-default-export
export const matchingSyndications = async ({
  filters = {},
  mentionId,
  mentionType,
  streamId,
  options,
}: {
  filters?: Partial<StreamRequestFilters>;
  mentionId: number;
  mentionType: MentionType;
  streamId: number;
  options?: Partial<AxiosRequestConfig>;
}): Promise<MatchingSyndicationsResponse["syndications_matching_stream"]> => {
  const response = await $streemApiV1.get<MatchingSyndicationsResponse>(
    `mentions/${mentionId}/syndications_matching_stream`,
    {
      params: {
        stream_id: streamId,
        mention_type: mentionType,
        ...filters,
      },
      ...options,
    }
  );

  return response.data.syndications_matching_stream;
};
